import { FC } from 'react';
import { SummaryStatCard } from 'components/summary-stat-card/summary-stat-card';
import type { PackageLibraryAggregations, SummaryCardType } from './types';
import { SUMMARY_TILES, formatCount, formatDelta } from './utils';
import styles from './summary-cards.module.scss';

interface PackageLibrarySummaryCardsProps {
  aggregations: PackageLibraryAggregations | undefined;
  onCardClick?: (card: SummaryCardType) => void;
}

const PackageLibrarySummaryCards: FC<PackageLibrarySummaryCardsProps> = ({
  aggregations,
  onCardClick,
}) => {
  return (
    <div className={styles.cardsContainer}>
      {SUMMARY_TILES.map(
        ({
          title,
          aggregationKey,
          cardType,
          format,
          valueColor,
          tooltipText,
        }) => {
          const rawValue = aggregations?.[aggregationKey];
          const value =
            format === 'delta' ? formatDelta(rawValue) : formatCount(rawValue);

          return (
            <div className={styles.cardCell} key={title}>
              <SummaryStatCard
                title={title}
                value={value}
                valueColor={valueColor}
                tooltipText={tooltipText}
                onFilterClick={
                  cardType && onCardClick
                    ? () => onCardClick(cardType)
                    : undefined
                }
                filterTooltip={cardType ? `Filter by ${title}` : undefined}
              />
            </div>
          );
        }
      )}
    </div>
  );
};

export { PackageLibrarySummaryCards };
